var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"h5-dialog",class:{ loading: _vm.isLoading }},[(_vm.isLoading)?_c('img',{staticClass:"loading-img",attrs:{"src":require("../assets/images/loading.png"),"alt":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }